module.exports = __webpack_public_path__ + "static/img/3.fd73754f.png";